define('modules/profiles/subviews/views/profile.following.btn.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/following.view",
    "text!modules/profiles/subviews/templates/profile.following.btn.template.html"
], function (Prospector,
             $, _, Backbone, Marionette,
             FollowingView,
             Template) {
    var ProfileFollowingView = FollowingView.extend({
        className: 'buttons follow mBottom10',
        template: _.template(Template),
        initialize: function (options) {
            this.parent = options.parent;
            FollowingView.prototype.initialize.call(this, options);
        }
    });
    return ProfileFollowingView;
});

